export enum CommentActionResult {
  SUCCESS = 'success',
  TWO_MINUTES = '2 minutes',
}
